<mojo-modal
  [confirmAction]="getConfirmAction()"
  [disableSave]="isDisableSave()"
>
  <form [formGroup]="form">
    <mojo-editor
      formControlName="comments"
      [placeholder]="'Comment'"
      toolbar=""
      [material]="true"
      [maxLength]="3000"
    >
    </mojo-editor>
  </form>
</mojo-modal>
